import { Modal } from 'antd';

const text= {
    1: '请将商品放入分拣设备，或按下“处理订单”按钮。\n' + 'Тауарды сұрыптау құрылғысына салыңыз немесе тапсырысты өңдеу түймесін басыңыз.',
    2: '商品已成功处理并确认，状态为 STOCK_IN。\n' + 'Тауар сәтті өңделіп, расталды, мәртебесі STOCK_IN.'
};

export function NotifModal({ number, open, onClose }) {
    return (
        <Modal
            open={open}
            onOk={onClose}
            onCancel={onClose}
            footer={false}
        >
            <div
                style={{
                    textAlign: 'center',
                    color: 'white',
                    fontSize: '24px',
                    margin: 'auto',
                }}
            >
                {text[number]}
            </div>
        </Modal>
    );
}
